import { StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';

export const pantryDetailsPromptStyleSheet = StyleSheet.create({
  view: {
    color: Colors.primaryColor,
    backgroundColor: Colors.white,
  },
  container: {
    paddingHorizontal: 16,
    paddingTop: 18,
    paddingBottom: 18,
    flexDirection: Layout.isCompactScreen ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: Layout.isCompactScreen ? 'flex-start' : 'center',
    flexShrink: 1,
  },
  leftContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  buttonContainer: {
    marginTop: Layout.isCompactScreen ? 8 : 0,
    marginLeft: Layout.isCompactScreen ? 50 : 16,
  },
  promptContainer: {
    flexShrink: 1,
    paddingLeft: Layout.isCompactScreen ? 16 : 20,
  },
  promptLabelContainer: {
    flexShrink: 1,
  },
  promptLabel: {
    fontSize: 12,
    color: Colors.grayText,
  },
  text: {
    fontSize: 16,
    marginBottom: 4,
  },
  icon: {
    color: Colors.brightRed,
    height: 32,
    width: 32,
  },
  button: {
    color: Colors.primaryColor,
    paddingHorizontal: 20,
  },
});
